// extracted by mini-css-extract-plugin
export var externalLink = "_6u-0";
export var internalLinkLabel = "_6u-1";